<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<page-content>
  <div class="form-container">
    <smart-input [(model)]="codeSnippet" key="name" [hideDescription]="true"></smart-input>
    <smart-input [(model)]="codeSnippet" key="title" [hideDescription]="true"></smart-input>
    <smart-input [(model)]="codeSnippet" key="type" [hideDescription]="true"></smart-input>
  </div>
  <div class="code-container" *ngIf="!isLoading && !!codeSnippet.type">
    <code-area [isString]="true" [parent]="codeSnippet" [type]="codeSnippet.type" [value]="codeSnippet.code" key="code"></code-area>
    <button (click)="onSave()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
  </div>
</page-content>
